import hubSettingsRoutes from '@app2/modules/Hubs/Settings/settings.router';

export default [
  {
    path: '/hubs',
    name: 'hubs',
    component: () => import(/* webpackChunkName: "hubs-v2" */ '@app2/modules/Hubs/Listing/Pages/Index'),
  },
  {
    path: '/hubs/templates',
    name: 'hubTemplates',
    component: () => import(/* webpackChunkName: "hubs-v2" */ '@app2/modules/Hubs/Templates/Pages/Index'),
  },
  {
    path: '/hubs/:hash',
    component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Index'),
    children: [
      {
        path: '',
        name: 'hubPreviewDashboard', // Use the same name as the editor route
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Preview/Index'),
        meta: {
          showSubnav: true
        }
      },
      {
        path: 'contacts',
        name: 'audienceHub',
        component: require('@app2/modules/Audience/Listing/Pages/IndexHub').default,
        meta: {
          hideAddMedia: true,
          hideSidenavBackButton: true,
          showSubnav: true
        }
      },
      {
        path: 'pricing',
        name: 'Pricing',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Monetization/Pricing/Index'),
        meta: {
          showSubnav: true,
          hideSidenavBackButton: true,
        }
      },
      {
        path: 'transactions',
        name: 'Transactions',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Monetization/Transactions/Index'),
        meta: {
          showSubnav: true,
          hideSidenavBackButton: true,
        }
      },
      {
        path: 'payouts',
        name: 'Payouts',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Monetization/Payouts/Index'),
        meta: {
          showSubnav: true,
          hideSidenavBackButton: true,
        }
      },
      {
        path: 'checkoutSettings',
        name: 'CheckoutSettings',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Monetization/CheckoutSettings/Index'),
        meta: {
          showSubnav: true,
          hideSidenavBackButton: true,
        }
      },
      {
        path: 'editor',
        name: 'hubEditor',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Editor/Pages/Index'),
        redirect: '/hubs/:hash/editor/pages/homepage'
      },
      {
        path: 'editor/pages/dashboard',
        redirect: '/hubs/:hash/editor/pages/homepage'
      },
      {
        path: 'editor/pages/homepage',
        name: 'hubEditorDashboard',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Editor/Pages/Index'),
      },
      {
        path: 'editor/pages/:page',
        name: 'hubEditorPage',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Editor/Pages/Index'),
      },
      {
        path: 'audience',
        name: 'hubAudience',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Audience/Pages/Index'),
      },
      {
        path: 'settings',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Settings/Pages/Index'),
        name: 'hubSettings',
        children: hubSettingsRoutes
      },
      {
        path: 'payment',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Payment/Pages/Index'),
        name: 'hubPayment'
      },
      {
        path: 'ai-tools',
        name: 'hubAItools',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/AITools/Index.vue'),
        meta: {
          hideSidenavBackButton: true,
          showSubnav: true
        }
      },
      {
        path: 'activity',
        name: 'hubActivity',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Activity/Index.vue'),
        meta: {
          hideSidenavBackButton: true,
          showSubnav: true
        }
      },
      {
        path: 'content',
        name: 'hubContent',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Content/Index.vue'),
        meta: {
          hideSidenavBackButton: true,
          showSubnav: true
        }
      },
      {
        path: 'analytics',
        name: 'hubAnalytics',
        component: () => import(/* webpackChunkName: "hubs-v2" */'@app2/modules/Hubs/Analytics/Index.vue'),
        meta: {
          hideSidenavBackButton: true,
          showSubnav: true
        }
      },
    ]
  },
];
